import React from "react";
import { ThinTextAreaField } from "../../../../common/GeneralComponent";

const CancelledFields = ({ data }) => {
  const implementationDetails = data?.implementationDetails || {};
  // Extract cancelled/excluded-specific remarks
  const cancelledRemarks = implementationDetails?.remarks || implementationDetails?.overall_remarks || "No remarks available";

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div className="w-full md:col-span-3">
          <ThinTextAreaField isRequired={false} label="Remarks / Details" value={cancelledRemarks} disabled />
        </div>
      </div>
      {/* Empty slots for balance */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div className="w-full"></div>
        <div className="w-full"></div>
        <div className="w-full"></div>
      </div>
    </div>
  );
};

export default CancelledFields;